<template>
  <div class="riseup-header">
    <div class="right-nav">
      <slot></slot>
    </div>
    <div class="logo">
      <img :src="require('@/assets/riseup_logo.svg')"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RiseupHeader',
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';
  @import '../../scss/global-variables';

  .riseup-header {
    @include responsive-padding;
    position: sticky;
    position: -webkit-sticky;
    top: 0px;
    width: 100%;
    height: $app_header_height;
    border-bottom: 1px solid $riseup_gray_0;
    background-color: $riseup_white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 10;

    .logo {
      display: inline-block;
      margin-top: 5px;
    }

    .right-nav {
      display: inline-block;
      cursor: pointer;
    }
  }

</style>
